import React, { useEffect, useState } from 'react'

import { wrap } from '@popmotion/popcorn'
import { AnimatePresence, motion } from 'framer-motion'
import { graphql, useStaticQuery } from 'gatsby'
import { Lead, LeadCard } from './components'
import * as Styles from './LeadScore.module.css'

const LeadScore = () => {
  // Controls current highlighted Lead in the carousel
  const [currentLead, setCurrentLead] = useState(0)
  const leadIndex = wrap(0, LeadsArray.length, currentLead)
  useEffect(() => {
    const slideShow = setTimeout(() => {
      setCurrentLead(currentLead + 1)
    }, 5000)
    return () => {
      clearTimeout(slideShow)
    }
  }, [currentLead])

  /**
   * Gets all images into the images folder,
   * then finds the right image based on the filename.
   * TODO: This is temporary while the images are not implemented in the API
   **/

  const {
    allFile: { edges: images },
  } = useStaticQuery(imageQuery)
  const getImageNode = (imageName) => {
    const [imageUrl] = images.filter((imageUrl) => {
      return imageUrl.node.name === imageName
    })
    return imageUrl.node
  }

  return (
    <div className={Styles.section}>
      <div className={Styles.decoration} />

      <div className={Styles.wrapper}>
        <div className={Styles.leadCard}>
          <motion.div
            initial={{ opacity: 0, x: -200 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.85,
                delay: 0.5,
              },
            }}
          >
            <AnimatePresence initial={false} exitBeforeEnter>
              <div key={leadIndex}>
                <motion.div
                  initial={{ opacity: 0, x: -200 }}
                  animate={{
                    opacity: 1,
                    x: 0,
                  }}
                  exit={{
                    x: 200,
                    opacity: 0,
                  }}
                  transition={{
                    x: {
                      type: 'spring',
                      stiffness: 800,
                      damping: 100,
                      duration: 0.35,
                    },
                    opacity: { duration: 0.35 },
                  }}
                >
                  <LeadCard
                    companyLogo={getImageNode(
                      LeadsArray[leadIndex].companyLogo
                    )}
                    data={LeadsArray[leadIndex]}
                  />
                </motion.div>
              </div>
            </AnimatePresence>
          </motion.div>
        </div>
        <div className="flex-grow scale-75 origin-right ">
          <motion.div
            className={Styles.leadScore}
            variants={container}
            initial="hidden"
            animate="show"
          >
            {LeadsArray.map(({ companyLogo, ...props }, index) => {
              return (
                <motion.div variants={item} key={index}>
                  <Lead companyLogo={getImageNode(companyLogo)} {...props} />
                </motion.div>
              )
            })}
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default LeadScore

// Animation Object
export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.1,
    },
  },
}
const item = {
  hidden: { opacity: 0, y: 80 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      when: 'beforeChildren',
      duration: 0.35,
    },
  },
}

// Temp Data
export const LeadsArray = [
  {
    companyLogo: 'dell',
    companyName: 'Dell',
    leadName: 'Stella Willis',
    industryCategory: 'Computer Software',
    numberOfEmployees: '51-200',
    leadScore: 87,
    tags: [],
    tracking: {
      sessions: 8,
      events: 12,
    },
  },
  {
    companyLogo: 'jeep',
    companyName: 'Jeep',
    leadName: 'Nellie Wallace',
    industryCategory: 'Auto Manufacturers',
    numberOfEmployees: '51-200',
    leadScore: 68,
    tags: [],
    tracking: {
      sessions: 3,
      events: 7,
    },
  },
  {
    companyLogo: 'pepsico',
    companyName: 'Pepsico',
    leadName: 'Curtis Ryan',
    industryCategory: 'Food and Beverage',
    numberOfEmployees: '51-200',
    leadScore: 56,
    tags: [],
    tracking: {
      sessions: 2,
      events: 7,
    },
  },
  {
    companyLogo: 'spotify',
    companyName: 'Spotify',
    leadName: 'Mark Franklin Longname',
    industryCategory: 'Audio Streaming',
    numberOfEmployees: '51-200',
    leadScore: 36,
    tags: [],
    tracking: {
      sessions: 2,
      events: 5,
    },
  },
  {
    companyLogo: 'tesla',
    companyName: 'Tesla',
    leadName: 'Mark Franklin',
    industryCategory: 'Auto Manufacturers',
    numberOfEmployees: '51-200',
    leadScore: 36,
    tags: [],
    tracking: {
      sessions: 1,
      events: 4,
    },
  },
  {
    companyLogo: 'walmart',
    companyName: 'Walmart',
    leadName: 'Mark Franklin',
    industryCategory: 'Food Retail',
    numberOfEmployees: '51-200',
    leadScore: 18,
    tags: [],
    tracking: {
      sessions: 1,
      events: 3,
    },
  },
]

// Temp queries all images
export const imageQuery = graphql`
  {
    allFile(filter: { sourceInstanceName: { eq: "images" } }) {
      edges {
        node {
          name
          url
          publicURL
          childImageSharp {
            gatsbyImageData(width: 200)
          }
        }
      }
    }
  }
`
